import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

import classNames from "classnames";

import { IOrganization } from "@src/types/api";

import { DeleteModalParams } from "@LeagueManagement/Organizations/types/organizations";

const DeleteOrganizationModal = ({
    show,
    setShow,
    organization,
    handleDelete,
}: DeleteModalParams): React.JSX.Element => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered={true}
            className={classNames("deleteOrganizationModal")}
        >
            <Modal.Header>
                <Modal.Title>Delete Organization?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <b>Name:</b> {organization?.name}
                        <br />
                        <b>Org User:</b> {organization?.primaryUser.name} (
                        {organization?.primaryUser.email})<br />
                        <br />
                        Note: This will delete the organization and disassociate
                        all teams from it. It <b>will not</b> delete any of the
                        teams or the org user's account.
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleDelete(organization?.id as IOrganization["id"]);
                        setShow(false);
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteOrganizationModal;
